import { render, staticRenderFns } from "./deliveryCharge.vue?vue&type=template&id=45cf2b8e&"
import script from "./deliveryCharge.vue?vue&type=script&lang=js&"
export * from "./deliveryCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports